/* lua.js generated code 0.3.0 */
 //http://lua-users.org/wiki/SplitJoin

let GlobalMask = require("clover/utils/GlobalMask")

string.isEmpty = function (str) {
    return type(str) !== "string" || !str || $len(str) === 0
}

string.starts = function (String, Start) {
    return string.sub(String, 1, string.len(Start)) === Start
}
string.ends = function (String, End) {
    return End === "" || string.sub(String, -string.len(End)) === End
}
// string.getUnicode = function (str) {
//     if (type(str) !== "string") {
//         return str
//     }
//     var resultStr = ""
//     var i = 1
//     var num1 = string.byte(str, i)[0]
//     while (num1 != null) {
//         var tempVar1, tempVar2
//         if (num1 >= 0x00 && num1 <= 0x7f) {
//             tempVar1 = num1
//             tempVar2 = 0
//         } else if (bit.band(num1, 0xe0) === 0xc0) {
//             var t1 = 0
//             var t2 = 0
//             t1 = bit.band(num1, bit.rshift(0xff, 3))
//             i = i + 1
//             num1 = string.byte(str, i)[0]
//             t2 = bit.band(num1, bit.rshift(0xff, 2))
//             tempVar1 = bit.bor(t2, bit.lshift(bit.band(t1, bit.rshift(0xff, 6)), 6))
//             tempVar2 = bit.rshift(t1, 2)
//         } else if (bit.band(num1, 0xf0) === 0xe0) {
//             var t1 = 0
//             var t2 = 0
//             var t3 = 0
//             t1 = bit.band(num1, bit.rshift(0xff, 3))
//             i = i + 1
//             num1 = string.byte(str, i)[0]
//             t2 = bit.band(num1, bit.rshift(0xff, 2))
//             i = i + 1
//             num1 = string.byte(str, i)[0]
//             t3 = bit.band(num1, bit.rshift(0xff, 2))
//             tempVar1 = bit.bor(bit.lshift(bit.band(t2, bit.rshift(0xff, 6)), 6), t3)
//             tempVar2 = bit.bor(bit.lshift(t1, 4), bit.rshift(t2, 2))
//         }
//         resultStr = resultStr + string.format("\\u%02x%02x", tempVar2, tempVar1)
//         i = i + 1
//         num1 = string.byte(str, i)[0]
//     }
//     var result = table()
//     var arr = string.split(resultStr, "\\u")
//     for (var _ = 1, v = arr[1]; v; _++, v = arr[_]) {
//         table.insert(result, tonumber("0x" + v))
//     }
//     // WARN: maybe multi result
//     return unpack(result)
// }
string.getUtf8Str = function (code) {
    if (type(code) !== "number") {
        return code
    }
    var str = string.format("%#x", code)
    str = "\\u" + string.sub(str, 3, $len(str))
    var resultStr = ""
    var i = 1
    while (true) {
        var num1 = string.byte(str, i)[0]
        var unicode
        if (num1 != null && string.sub(str, i, i + 1) === "\\u") {
            unicode = tonumber("0x" + string.sub(str, i + 2, i + 5))
            i = i + 6
        } else if (num1 != null) {
            unicode = num1
            i = i + 1
        } else {
            break
        }
        if (unicode <= 0x007f) {
            resultStr = resultStr + string.char(bit.band(unicode, 0x7f))
        } else if (unicode >= 0x0080 && unicode <= 0x07ff) {
            resultStr = resultStr + string.char(bit.bor(0xc0, bit.band(bit.rshift(unicode, 6), 0x1f)))
            resultStr = resultStr + string.char(bit.bor(0x80, bit.band(unicode, 0x3f)))
        } else if (unicode >= 0x0800 && unicode <= 0xffff) {
            resultStr = resultStr + string.char(bit.bor(0xe0, bit.band(bit.rshift(unicode, 12), 0x0f)))
            resultStr = resultStr + string.char(bit.bor(0x80, bit.band(bit.rshift(unicode, 6), 0x3f)))
            resultStr = resultStr + string.char(bit.bor(0x80, bit.band(unicode, 0x3f)))
        }
    }
    //resultStr=resultStr..'\0'
    return resultStr
}
localize = function (key, params) {
    TODO("deprecated. use getText() instead.")
    // WARN: maybe multi result
    return getText(key, params)
}
hex2ccc3 = function (hex) {
    var integer = tonumber(hex, 16)
    var ret = he.HeDisplayUtil.ccc3FromUInt(integer)
    return ret
}
ccc4fFromccc4b = function (c4b) {
    // WARN: maybe multi result
    return cc.c4f(c4b.r / 255, c4b.g / 255, c4b.b / 255, c4b.a / 255)
}

var _oldSetTimeout = setTimeout

setTimeOut = function (func, time) {
    return _oldSetTimeout(func, time * 1000)
    // var scheduleScriptFuncID
    // time = time || 1
    // function onScheduleScriptFunc() {
    //     if (func) {
    //         func()
    //     }
    //     if (scheduleScriptFuncID != null) {
    //         cc.Director.getInstance().getScheduler().unscheduleScriptEntry(scheduleScriptFuncID)
    //     }
    // }
    // scheduleScriptFuncID = cc.Director.getInstance().getScheduler().scheduleScriptFunc(onScheduleScriptFunc, time, false)
    // return scheduleScriptFuncID
}
cancelTimeOut = function (timeOutID) {
    if (timeOutID != null) {
        clearTimeout(timeOutID)
    }
}
delay = function (timeBeforeDelay) {
    function delay(dt) {
        var test = 0
        for (var i = 1; i <= 100000; i += 1) {
            for (var j = 1; j <= 10000; j += 1) {
                test = test + 1
            }
        }
    }
    setTimeOut(delay, timeBeforeDelay)
}
table.clone = function (t, nometa) {
    if (!t) {
        return 
    }
    var u = table()
    extend(u, t)
    // if (!nometa) {
    //     setmetatable(u, getmetatable(t))
    // }
    // for (var i in t) {
    //     var v = t[i]
    //     if (type(v) === "table") {
    //         u[i] = table.clone(v)
    //     } else {
    //         u[i] = v
    //     }
    // }
    return u
}
table.indexOf = function (t, v) {
    for (var i = 1, v_ = t[1]; v_; i++, v_ = t[i]) {
        if (v_ === v) {
            return i
        }
    }
    return null
}
table.keyOf = function (t, v) {
    for (var k in t) {
        var v_ = t[k]
        if (v_ === v) {
            return k
        }
    }
    return null
}
table.includes = function (t, value) {
    return table.indexOf(t, value)
}
table.removeValue = function (t, value) {
    var index = table.indexOf(t, value)
    if (index) {
        table.remove(t, index)
    }
    return t
}
table.unique = function (t) {
    var seen = table()
    for (var i = 1, v = t[1]; v; i++, v = t[i]) {
        if (!table.includes(seen, v)) {
            table.insert(seen, v)
        }
    }
    return seen
}
table.union = function (t0, t1) {
    var t = table()
    for (var i = 1, v = t0[1]; v; i++, v = t0[i]) {
        table.insert(t, v)
    }
    for (var i = 1, v = t1[1]; v; i++, v = t1[i]) {
        table.insert(t, v)
    }
    return t
}
table.merge = function (t0, t1) {
    var t = table()
    for (var k in t0) {
        var v = t0[k]
        t[k] = v
    }
    for (var k in t1) {
        var v = t1[k]
        t[k] = v
    }
    return t
}
table.combine = function (t0, t1) {
    for (var k in t1) {
        var v = t1[k]
        table.insert(t0, v)
    }
    return t0
}
table.removeAll = function (t) {
    var $limit62 = $len(t)
    for (var i = 1; i <= $limit62; i += 1) {
        t[i] = null
    }
    for (var k in t) {
        t[k] = null
    }
}
table.keys = function (t) {
    var keys = table()
    for (var k in t) {
        table.insert(keys, k)
    }
    return keys
}
table.values = function (t) {
    var values = table()
    for (var k in t) {
        var v = t[k]
        table.insert(values, v)
    }
    return values
}
table.last = function (t) {
    return t[$len(t)]
}
table.append = function (t, moreValues) {
    for (var i = 1, v = moreValues[1]; v; i++, v = moreValues[i]) {
        table.insert(t, v)
    }
    return t
}
table.each = function (t, func) {
    for (var k in t) {
        var v = t[k]
        func(v, k)
    }
}
table.find = function (t, func) {
    for (var k in t) {
        var v = t[k]
        if (func(v)) {
            return [v, k]
        }
    }
    return [null]
}
table.filter = function (t, func) {
    var matches = table()
    for (var k in t) {
        var v = t[k]
        if (func(v, k)) {
            table.insert(matches, v)
        }
    }
    return matches
}

//table.random({},{},{}...)按顺序从列表中随机一个值，会修改传进来的table,如果最后一个不是table,则作为默认值返�?table.random = function () {
table.random = function () {
    var __VA_ARG = $slice(arguments, 0)
    var p = table([2, __VA_ARG])
    var xdefault = null
    if ($len(p) > 2) {
        if (type(p[$len(p)]) !== "table") {
            xdefault = table.remove(p)
        }
    }
    for (var _ = 1, t = p[1]; t; _++, t = p[_]) {
        assert(type(t) === "table", "table expected")
        var len = $len(t)
        if (len > 1) {
            var idx = math.random(1, len)
            return table.remove(t, idx)
        } else if (len === 1) {
            return table.remove(t, 1)
        }
    }
    return xdefault
}
table.tostring = function (tbl, indent, limit, depth, jstack) {
    limit = limit || 1000
    depth = depth || 7
    jstack = jstack || {
        name: "top"
    }
    var i = 0
    var output = table()
    if (type(tbl) === "table") {
        // very important to avoid disgracing ourselves with circular referencs...
        for (var i in jstack) {
            var t = jstack[i]
            if (tbl === t) {
                return "<" + i + ">,\n"
            }
        }
        jstack[jstack.name] = tbl
        table.insert(output, "{\n")
        var name = jstack.name
        for (var key in tbl) {
            var value = tbl[key]
            var innerIndent = (indent || " ") + (indent || " ")
            table.insert(output, innerIndent + tostring(key) + " = ")
            jstack.name = name + "." + tostring(key)
            table.insert(output, value === tbl && "<parent>," || table.tostring(value, innerIndent, limit, depth, jstack))
            i = i + 1
            if (i > limit) {
                table.insert(output, (innerIndent || "") + "...\n")
                break
            }
        }
        table.insert(output, indent && (indent || "") + "},\n" || "}")
    } else {
        if (type(tbl) === "string") {
            tbl = string.format("%s", tbl)
        } // quote strings
        table.insert(output, tostring(tbl) + ",\n")
    }
    // WARN: maybe multi result
    return table.concat(output)
}
table.insertIfNotExist = function (t, v) {
    if (t) {
        if (!table.indexOf(t, v)) {
            table.insert(t, v)
        }
    } else {
        t = table([0, v])
    }
    return t
}
table.removeIfExist = function (t, v) {
    if (t) {
        var i = table.indexOf(t, v)
        if (i) {
            // WARN: maybe multi result
            return table.remove(t, i)
        }
        for (var k in t) {
            var v_ = t[k]
            if (v_ === v) {
                t[k] = null
                return v_
            }
        }
    }
    return null
}
table.size = function (t) {
    var s = 0
    for (var k in t) {
        var v = t[k]
        if (v != null) {
            s = s + 1
        }
    }
    return s
}
// added in ver 1.27
table.isEmpty = function (t) {
    return !t || !next(t)[0]
}
table.getNotKV = function (t, i) {
    var index = 0
    var [key, value] = [null, null]
    for (var k in t) {
        var v = t[k]
        if (v != null) {
            index = index + 1
            if (index === i) {
                value = v
                key = k
                break
            }
        }
    }
    // FIXME: multi result
    return [key, value]
}
table.exist = function (t, v) {
    for (var k in t) {
        var v_ = t[k]
        if (v_ === v) {
            return true
        }
    }
    return false
}

// Just For Test Phase ---------------------------------------------------------------------------------
function printConstTable(t) {
    cc.log("---------------- Constants Table Error -----------------")
    for (var k in t) {
        var v = t[k]
        cc.log(k, v)
    }
}

table.serialize = function (t) {
    if (!t) {
        return JSON.stringify(t)
    }
    if (t.__isLuaTable) {
        t = $tableToObj(t)
    }
    return JSON.stringify(t)
}
table.deserialize = function (str) {
    if (!str) {
        return null
    }
    if (typeof str === 'object') {
        return str
    }
    var result = null
    function deserialize_cjson() {
        result = JSON.parse(str)
    }
    pcall(deserialize_cjson)
    return result
}
table.const = function (t) {
    return t
}

isInt = function (v) {
    if (type(v) === "number") {
        if (Math.floor(v) === v) {
            return true
        }
    }
    return false
}

convertSecondToHHMMSSFormat = function (second) {
    var __VA_ARG = $slice(arguments, 1)
    assert(type(second) === "number")
    assert($len(table([2, __VA_ARG])) === 0)
    var minute = Math.floor(second / 60)
    var lastSecond = second - minute * 60
    var hour = Math.floor(minute / 60)
    var lastMinute = minute - hour * 60
    var str = string.format("%02d:%02d:%02d", hour, lastMinute, lastSecond)
    return str
}
//秒转天时分秒，缺的不显示
formatTime2Str = function (second) {
    var obj = {};
    var s = parseInt(second)
    obj["d"] = parseInt(s/86400);
    obj["h"] = parseInt(parseInt(s%86400)/3600);
    obj["m"] = parseInt(parseInt(s%3600)/60);
    obj["s"] = parseInt(s%60);
    var str = ""
    if(obj.d > 0) {
        str += obj.d + "天"
    }
    if(obj.h > 0) {
        str += obj.h + "小时"
    }
    if(obj.m > 0) {
        str += obj.m + "分钟"
    }
    if(obj.s > 0) {
        str += obj.s + "秒"
    }
    return str
}
formatTime2Str2 = function (microsecond) {
    let data = new Date(microsecond)
    return `${data.getFullYear()}年${data.getMonth() + 1}月${data.getDate()}日`
}
//两个毫秒时间戳是否是同年同月同日
isSameYMD = function(t1, t2) {
    return formatDate(new Date(t1), 'yyyyMMdd') == formatDate(new Date(t2), 'yyyyMMdd')
}
parseDateStringToTimestamp = function (string) {
    var p = "(%d+)-(%d+)-(%d+) (%d+):(%d+):(%d+)"
    var [year, month, day, hour, min, sec] = string.match(p)
    var t = os.time({
        day: day,
        month: month,
        year: year,
        hour: hour,
        min: min,
        sec: sec
    })
    return t
}
verifyPhoneNumber = function (phoneNumber) {
    let p = "1[35678]%d+"
    let matchStr = phoneNumber.match(p)
    if (matchStr !== null && $len(matchStr) === $len(phoneNumber) && $len(matchStr) === 11) {
        return true
    } else {
        Toast.make("请输入正确的手机号～")
        return false
    }
}
getRandomIntAry = function (lower, upper, num) {
    let ary = table()
    if (upper <= lower) {
        return null
    }
    if (num >= upper - lower + 1) {
        let $var182 = lower,$limit183 = upper
        for (let i = $var182; i <= $limit183; i += 1) {
            ary[$len(ary) + 1] = i
        }
    } else {
        let $limit186 = num
        for (let i = 1; i <= $limit186; i += 1) {
            while (true) {
                let r = math.random(lower, upper)
                if (table.indexOf(ary, r) === null) {
                    ary[$len(ary) + 1] = r
                    break
                }
            }
        }
    }
    return ary
}
// -- since 1.37 临时解决自动换行问题
// -- width：一行的中文字符长度限制
// "在{c=255,204,0,255}旁边消除{c=255,255,255,255}就可以消掉{c=255,204,0,255}厚冰块！{c=255,255,255,255}"
// parseColorText和getColorText构造的文本有问题，换行解析不对。老代码保留，新代码请使用parseColorTextNew 以及 getColorTextNew
parseColorText = function (text) {
    let textAry = table()
    let [startIdx, endIdx] = string.find(text, "{[%w]+=[%w,.]+}")
    let firstText = string.sub(text, 1, endIdx)
    let r, g, b, a
    let $st197 = string.gmatch(firstText, "{c=(%d+),(%d+),(%d+),(%d+)}")
    while(1) {
        let t = $st197[0]($st197[1], $st197[2])
        let res1 = t[0]
        let res2 = t[1]
        let res3 = t[2]
        let res4 = t[3]
        if (res1 == null) break
        $st197[2] = res1
        ;[r, g, b, a] = [tonumber(res1), tonumber(res2), tonumber(res3), tonumber(res4)]
    }
    let color = cc.c4b(r, g, b, a)
    firstText = string.sub(text, 1, startIdx - 1)
    textAry[1] = {
        text: firstText,
        color: color
    }
    if (endIdx === $len(text)) {
        return textAry
    } else {
        let nextTextAry = parseColorText(string.sub(text, endIdx + 1))
        let $limit202 = $len(nextTextAry)
        for (let i = 1; i <= $limit202; i += 1) {
            textAry[i + 1] = nextTextAry[i]
        }
        return textAry
    }
}
getColorText = function (text, fontNum, fontSize, fontScale) {
    fontNum = fontNum || 99999
    fontScale = fontScale || 1
    fontSize = fontSize || 16
    let tempTxtAry = parseColorText(text)
    let txtAry = table(table())
    let charColors = table()
    let lineIndex = 1
    let lineFontNum = 0
    let $limit210 = $len(tempTxtAry)
    for (let i = 1; i <= $limit210; i += 1) {
        let txtInfo = tempTxtAry[i]
        let txtColor = txtInfo.color
        let fixText = ""
        let $st215 = string.gfind(txtInfo.text, "[%z\\1-\\127\\194-\\244][\\128-\\191]*")
        while(1) {
            let t = $st215[0]($st215[1], $st215[2])
            let uchar = t[0]
            if (uchar == null) break
            $st215[2] = uchar
            if (uchar !== "\n") {
                let charNum = 1
                if (uchar === " ") {
                    charNum = 0.25
                } else if (tonumber(uchar)) {
                    charNum = 0.65
                }
                if (lineFontNum >= fontNum || (lineFontNum + charNum > fontNum)) {
                    if ($len(fixText) > 0) {
                        table.insert(txtAry[lineIndex], {
                            text: fixText,
                            color: txtColor
                        })
                    }
                    lineFontNum = 0
                    fixText = ""
                    lineIndex = lineIndex + 1
                    txtAry[lineIndex] = table()
                }
                lineFontNum = lineFontNum + charNum
            } else {
                if ($len(fixText) > 0) {
                    table.insert(txtAry[lineIndex], {
                        text: fixText,
                        color: txtColor
                    })
                }
                lineFontNum = 0
                lineIndex = lineIndex + 1
                txtAry[lineIndex] = table()
                fixText = ""
            }
            fixText = fixText + uchar
        }
        if ($len(fixText) > 0) {
            table.insert(txtAry[lineIndex], {
                text: fixText,
                color: txtColor
            })
        }
    }
    let textC = cc.Node.create()
    let firstLabel = cc.Label.createWithSystemFont(txtAry[1][1].text, "Arial", fontSize)
    let textHeight = firstLabel.getContentSize().height * ($len(txtAry) * 1.1 - 0.1)
    let [posX, posY] = [0, textHeight]
    let maxLineWidth = 0
    let $limit225 = $len(txtAry)
    for (let i = 1; i <= $limit225; i += 1) {
        let lineAry = txtAry[i]
        posX = 0
        let lineTxt = ""
        let $limit230 = $len(lineAry)
        for (let j = 1; j <= $limit230; j += 1) {
            let label
            if (firstLabel !== null) {
                label = firstLabel
                firstLabel = null
            } else {
                label = cc.Label.createWithSystemFont(lineAry[j].text, "Arial", fontSize)
            }
            textC.addChild(label)
            label.setTextColor(lineAry[j].color)
            label.setAnchorPoint(cc.p(0, 0))
            label.setPosition(posX, posY)
            let lSize = label.getContentSize()
            posX = posX + lSize.width
            lineTxt = lineTxt + lineAry[j].text
            if (j === $len(lineAry)) {
                posY = posY - lSize.height - lSize.height / 10
                if (maxLineWidth < posX) {
                    maxLineWidth = posX
                }
            }
        }
    }
    textC.setContentSize(cc.size(maxLineWidth, textHeight))
    return textC
}
parseColorTextNew = function (text) {
    let textAry = table()
    let [startIdx, endIdx] = string.find(text, "{[%w]+=[%w,.]+}")
    let firstText = string.sub(text, 1, endIdx)
    let r, g, b, a
    let $st268 = string.gmatch(firstText, "{c=(%d+),(%d+),(%d+),(%d+)}")
    while(1) {
        let t = $st268[0]($st268[1], $st268[2])
        let res1 = t[0]
        let res2 = t[1]
        let res3 = t[2]
        let res4 = t[3]
        if (res1 == null) break
        $st268[2] = res1
        ;[r, g, b, a] = [tonumber(res1), tonumber(res2), tonumber(res3), tonumber(res4)]
    }
    let color = cc.c4b(r, g, b, a)
    firstText = string.sub(text, 1, startIdx - 1)
    textAry[1] = table([1, "text", firstText], [1, "color", color])
    if (endIdx === $len(text)) {
        return textAry
    } else {
        let nextTextAry = parseColorTextNew(string.sub(text, endIdx + 1))
        let $limit273 = $len(nextTextAry)
        for (let i = 1; i <= $limit273; i += 1) {
            textAry[i + 1] = nextTextAry[i]
        }
        return textAry
    }
}
getColorTextNew = function (text, fontNum, fontSize, fontScale) {
    fontNum = fontNum || 99999
    fontScale = fontScale || 1
    fontSize = fontSize || 16
    let tempTxtAry = parseColorTextNew(text)
    let txtAry = table([0, table()])
    let charColors = table()
    let lineIndex = 1
    let lineFontNum = 0
    let $limit281 = $len(tempTxtAry)
    for (let i = 1; i <= $limit281; i += 1) {
        let txtInfo = tempTxtAry[i]
        let txtColor = txtInfo.color
        let fixText = ""
        let $st286 = string.gfind(txtInfo.text, "[%z\\1-\\127\\194-\\244][\\128-\\191]*")
        while(1) {
            let t = $st286[0]($st286[1], $st286[2])
            let uchar = t[0]
            if (uchar == null) break
            $st286[2] = uchar
            if (uchar !== "\n") {
                let charNum = 1
                if (uchar === " ") {
                    charNum = 0.25
                } else if (tonumber(uchar)) {
                    charNum = 0.65
                } else if (string.match(uchar, "[0-9a-zA-Z]")) {
                    charNum = 0.5
                }
                if (lineFontNum >= fontNum || (lineFontNum + charNum > fontNum)) {
                    if ($len(fixText) > 0) {
                        table.insert(txtAry[lineIndex], table([1, "text", fixText], [1, "color", txtColor]))
                    }
                    lineFontNum = 0
                    fixText = ""
                    lineIndex = lineIndex + 1
                    txtAry[lineIndex] = table()
                }
                lineFontNum = lineFontNum + charNum
            } else {
                if ($len(fixText) > 0) {
                    table.insert(txtAry[lineIndex], table([1, "text", fixText], [1, "color", txtColor]))
                }
                lineFontNum = 0
                lineIndex = lineIndex + 1
                txtAry[lineIndex] = table()
                fixText = ""
            }
            fixText = fixText + uchar
        }
        if ($len(fixText) > 0) {
            table.insert(txtAry[lineIndex], table([1, "text", fixText], [1, "color", txtColor]))
        }
    }
    let textC = cc.Node.create()
    let firstLabel = cc.Label.createWithSystemFont(txtAry[1][1].text, "Arial", fontSize)
    let textHeight = firstLabel.getContentSize().height * (($len(txtAry) + 0) * 1.1 - 0.0)
    log.i("getColorText textHeight %s  txtAry %s", textHeight, $len(txtAry))
    let [posX, posY] = [0, textHeight]
    let maxLineWidth = 0
    let $limit296 = $len(txtAry)
    for (let i = 1; i <= $limit296; i += 1) {
        let lineAry = txtAry[i]
        posX = 0
        let lineTxt = ""
        let $limit301 = $len(lineAry)
        for (let j = 1; j <= $limit301; j += 1) {
            let label
            if (firstLabel !== null) {
                label = firstLabel
                firstLabel = null
            } else {
                label = cc.Label.createWithSystemFont(lineAry[j].text, "Arial", fontSize)
            }
            textC.addChild(label)
            label.setTextColor(lineAry[j].color)
            label.setAnchorPoint(cc.p(0, 0))
            label.setPosition(posX, posY)
            let lSize = label.getContentSize()
            posX = posX + lSize.width
            lineTxt = lineTxt + lineAry[j].text
            if (j === $len(lineAry)) {
                // log.i("getColorText height %s  i %s",lSize.height,i)
                let nHeight = lSize.height
                if (string.find(lineAry[j].text, "\n")) {
                    nHeight = nHeight / 2
                }
                posY = posY - nHeight - nHeight / 10
                if (maxLineWidth < posX) {
                    maxLineWidth = posX
                }
            }
        }
    }
    textC.setContentSize(cc.size(maxLineWidth, textHeight))
    // FIXME: multi result
    return [textC, textHeight]
}
parseColorTextH5 = function (text) {
    let textAry = []
    // let [startIdx, endIdx] =  str.indexOf("China");
    let startIdx = text.indexOf("{c=");
    let endIdx = text.indexOf("/c}");
    cc.log("startIdx",startIdx,endIdx)
    if(startIdx < 0 || endIdx < endIdx){
        // cc.log("textAry",textAry)
        return textAry
    }
    let content = text.substring(0,startIdx);
    let colorMsg = text.substring(startIdx+3,endIdx);
    cc.log("colorMsg",colorMsg)
    let arr = colorMsg.split(",")
    let color = cc.c4b(arr[0], arr[1], arr[2], arr[3])
    textAry[0] = {text:content,color:color}
    if (endIdx+3 == text.length){
        return textAry
    }else{
        let nextTextAry = parseColorTextH5(text.substring(endIdx+3))
        for (let i = 0; i < nextTextAry.length; i++) {
            textAry[i+1] = nextTextAry[i]
        }
        return textAry
    }
}
getColorTextH5 = function (text, fontNum, fontSize, fontScale) {
    fontNum = fontNum || 999
    fontScale = fontScale || 1
    fontSize = fontSize || 16
    let tempTxtAry = parseColorTextH5(text)
    // let txtAry = table([0, table()])
    let test = []
    test.push({t:1})
    let txtAry = []
    txtAry[0] = []
    let charColors = table()
    let lineIndex = 0
    let lineFontNum = 0
    let regE = new RegExp("^[A-Za-z]+$");
    for (let i = 0; i < tempTxtAry.length; i++) {
        let txtInfo = tempTxtAry[i]
        let txtColor = txtInfo.color
        let fixText = ""   
        for (let j = 0; j < txtInfo.text.length; j++) {
            let uchar = txtInfo.text[j];
            if (uchar != "\n"){
                let charNum = 1
                if (uchar == ""){
                    charNum = 0.25
                }else if (tonumber(uchar)){
                    charNum = 0.50 //0.65
                }else if (regE.test(uchar)) {
                    charNum = 0.5
                }else if (uchar == " ") {
                    charNum = 0.25
                }
                if (lineFontNum >= fontNum || (lineFontNum + charNum > fontNum)){
                    if (fixText.length > 0){
                        // table.insert(txtAry[lineIndex], {text:fixText, color:txtColor})
                        txtAry[lineIndex].push({text:fixText, color:txtColor})
                    }
                    lineFontNum = 0
                    fixText = ""
                    lineIndex = lineIndex + 1
                    txtAry[lineIndex] = [] //push line
                }
                lineFontNum = lineFontNum + charNum 
            }else{
                if(fixText.length > 0){
                    // table.insert(txtAry[lineIndex], {text:fixText, color:txtColor})
                    // txtAry[lineIndex] = {text:fixText, color:txtColor}
                    txtAry[lineIndex].push({text:fixText, color:txtColor})
                }
                lineFontNum = 0
                lineIndex = lineIndex + 1
                txtAry[lineIndex] = []
                fixText = ""
            }
            fixText = fixText + uchar
        }

        if (fixText.length > 0){
            // table.insert(txtAry[lineIndex], {text:fixText, color:txtColor}) 
            // txtAry[lineIndex] = {text:fixText, color:txtColor}
            txtAry[lineIndex].push({text:fixText, color:txtColor})
        }
    }
    cc.log("getColorTextH5 txtAry",txtAry)

    let textC = cc.Node.create()
    textC.setAnchorPoint(cc.p(0, 0))
    if(!txtAry[0][0]){ //错误的格式直接返回普通label
        let firstLabel = cc.Label.createWithSystemFont(text, "Arial", fontSize)
        textC.addChild(firstLabel)
        return textC
    }

    let firstLabel = cc.Label.createWithSystemFont(txtAry[0][0].text, "Arial", fontSize)
    // firstLabel.setLineHeight(fontSize+20)
    // let textHeight = firstLabel.getContentSize().height * ((txtAry.length + 0) * 1.1 - 0.0)
    // cc.log("getColorText textHeight %s  txtAry %s", textHeight, txtAry.length)

    let [posX, posY] = [0, -firstLabel.height]
    let oneLineHeight = firstLabel.height
    let maxLineWidth = 0
    for (let i = 0; i < txtAry.length; i++) {
        let lineAry = txtAry[i]
        posX = 0
        let lineTxt = ""
        for (let j = 0; j < lineAry.length; j++) {
            let label
            if (firstLabel !== null) {
                label = firstLabel
                firstLabel = null
            } else {
                label = cc.Label.createWithSystemFont(lineAry[j].text, "Arial", fontSize)
            }
            textC.addChild(label)
            label.setTextColor(lineAry[j].color)
            label.setAnchorPoint(cc.p(0, 0))
            label.setPosition(posX, posY)
            cc.log("getColorTextH5 posY",posY)
            let lSize = label.getContentSize()
            posX = posX + lSize.width
            lineTxt = lineTxt + lineAry[j].text
            if (j === lineAry.length-1) {
                // log.i("getColorText height %s  i %s",lSize.height,i)
                let nHeight = lSize.height
                if (lineAry[j].text.indexOf("\n")>=0){
                    nHeight = nHeight / 2
                }
                if ( i < txtAry.length-1){
                    posY = posY - nHeight - nHeight / 10 * 1
                }
                if (maxLineWidth < posX) {
                    maxLineWidth = posX
                }
            }
        }
    }

    let maxLineHeight = -posY
    if (txtAry.length == 1) maxLineHeight = oneLineHeight //一行的时候posY的值会计算多一行 所以这里处理下
    textC.setContentSize(cc.size(maxLineWidth, maxLineHeight))
    return textC
}

_safe_area_bottom = 0
_safe_area_top = 0
_safe_area_left = 0
_safe_area_right = 0
applySafeArea = function () {
    if (__IPHONEX) {
        _safe_area_top = 60
        _safe_area_bottom = 30
    }
    if (cc.sys.platform === cc.sys.WECHAT_GAME) {
        let sysInfo = mini.getSystemInfoSync()
        if(sysInfo.safeArea && sysInfo.safeArea.top) {
            _safe_area_top = 750 / sysInfo.screenWidth * sysInfo.safeArea.top
        } else {
            let model = sysInfo.model.toLowerCase()
            if (model.includes('vivo x21') || model.includes('vivo y85') ||
                // 小米8
                model.includes('mi 8') || model === 'sirius' || model === 'dipper') {
                _safe_area_top = 60
            } else if (sysInfo.statusBarHeight > 20) {
                _safe_area_top = 60
            }
        }
    }
    
}
layoutBottom = function (value) {
    value = value || 0
    return _safe_area_bottom + value
}
layoutTop = function (value) {
    value = value || 0
    return display.height - _safe_area_top - value
}
layoutRight = function (value) {
    value = value || 0
    return display.width - _safe_area_right - value
}
layoutLeft = function (value) {
    value = value || 0
    return _safe_area_left + value
}
angleToRad = function (v) {
    return v * Math.PI / 180
}

// Tests ---------------------------------------------------------------------------------------------
/* local T_STRING = "string"
local Class = table.class{ 
            prop1 = T_STRING, prop2 = T_STRING, prop3 = T_STRING, 
            dynamic1 = T_STRING, dynamic2 = T_STRING, dynamic3 = T_STRING 
        }
local bean = table.bean(Class, {
            prop1 = "Prop1",
            prop2 = "Prop2",
            prop3 = "Prop3",
        })

print(bean.prop1, bean.prop2, bean.prop3, bean.dynamic1, bean.dynamic2, bean.dynamic3)
bean.prop1 = nil
bean.dynamic1 = "Dynamic1"
print(bean.prop1, bean.prop2, bean.prop3, bean.dynamic1, bean.dynamic2, bean.dynamic3)
bean.dynamic2 = true                -- raise error here
bean.notexsit = true                -- raise error here
print(bean.notexsit)                -- raise error here
-- */
compareDate = function (date1, date2) {
    assert(date1.year)
    assert(date1.month)
    assert(date1.day)
    assert(date2.year)
    assert(date2.month)
    assert(date2.day)
    var date1Copy = {
        sec: 0,
        min: 0,
        hour: 0,
        day: date1.day,
        isdst: false,
        wday: date1.wday,
        yday: date1.yday,
        year: date1.year,
        month: date1.month
    }
    var date2Copy = {
        sec: 0,
        min: 0,
        hour: 0,
        day: date2.day,
        isdst: false,
        wday: date2.wday,
        yday: date2.yday,
        year: date2.year,
        month: date2.month
    }
    var time1 = os.time(date1Copy) || 0
    var time2 = os.time(date2Copy) || 0
    if (time1 < time2) {
        return -1
    } else if (time1 === time2) {
        return 0
    } else if (time1 > time2) {
        return 1
    }
}

generateUUID = function (){
    var d = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (d + Math.random()*16)%16 | 0;
        d = Math.floor(d/16);
        return (c=='x' ? r : (r&0x7|0x8)).toString(16);
    });
    return uuid;
}

// 只支持二级结�?// TODO:
buildResList = function (obj) {
    let preload_list = []
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            let element = obj[key];
            if (isArray(element)) {
                preload_list = preload_list.concat(element)                
            }else if(type(element) === "string"){
                preload_list.push(element)
            }else if(type(element) === "table"){
                // preload_list.concat(Object.values(element))
                for (let k in element) {
                    preload_list.push(element[k])
                }
            }
        }
    }
    return preload_list
}

unloadResList = function (resList) {
    ResManager.release(typeof resList === 'string'? [resList]: resList);
}

preloadWithLoading = function (preloadList,finishCallback, failCallback, cancelCallback, needMask = true) {
    return ResManager.loadWithTip(preloadList, finishCallback, failCallback, cancelCallback, needMask)
}

preloadWithLoadingPromise = function (preloadList, needMask) {
    return new Promise((resolve, reject) => {
        preloadWithLoading(preloadList, resolve, reject, reject, needMask)
    })
}

logOnline = function (message) {
    if (__DEBUG) {
        cc.error(message)
    }else {
        if (window.logCenter && window.logCenter.error) {
            logCenter.error.apply(logCenter, [message])
        }
    }
}
buildShareRewardIcons = function (bg) {
    let reward = UserManager.getInstance().dailyData.getCurrentShareReward()
    return buildRewardList(bg, reward)
}

buildRewardList = function (bg, reward, iconType) {
    let propItems = table()
    // let propItemWidth = 100
    iconType = iconType || 0
    let shareReward = cc.Sprite.create(bg)
    shareReward.setAnchorPoint(0.5, 0.5)
    // let len = $len(reward)
    let size = shareReward.getContentSize()
    if (size.width === 0) {
        size = cc.size(140, 121)
    }
    for (let key in reward) {
        let v = reward[key]
        if (v.num === 0) {
            continue
        }
        let icon = UIItemBuilder.createProp(v.itemId, v.num, iconType, false)[0]
        icon.setScale(0.9)
        // icon.setPosition((tonumber(key) - 1) * propItemWidth, 0)
        icon.setPosition(size.width / 2, size.height / 2)
        shareReward.addChild(icon, 5)
        table.insert(propItems, icon)
        icon.flyConfig = clone(v)
        icon.flyConfig.itemId = tonumber(v.itemId)
        icon.flyConfig.scale = 0.8
        icon.flyConfig.iconType = 1
    }
    if ($len(propItems) > 0) {
        return [true, shareReward, propItems]
    }else {
        return [false, null, null]
    }
}

getMainHideLevelConsumeEnergy = function (levelId, vague) {
    let levelType = LevelType.getLevelTypeByLevelId(levelId)
    let needEnergy = 5
    switch (levelType) {
        case GameLevelType.kMainLevel:
            needEnergy = require("clover/logic/userLevel/UserLevelTypeMainLevel").prototype.getConsumeEnergy.call(null, levelId, vague)
            break;
        case GameLevelType.kMysteryIsland:
            needEnergy = require("clover/logic/userLevel/UserLevelTypeMysteryIslandLevel").prototype.getConsumeEnergy.call(null, levelId, vague)
            break;
        default:
            break;
    }
    return needEnergy
}

getBezierControlPointByStartAndEnd = function (start, end, width) {
    let dis = Math.sqrt(Math.pow(start.x - end.x, 2) + Math.pow(start.y - end.y, 2)) || 1
    width = width || dis / 2
    let cosa = Math.abs(start.y - end.y) / dis
    let sina = Math.abs(start.x - end.x) / dis
    let deltaX = width * cosa
    let deltaY = width * sina
    let controlPoint_1 = cc.p(start.x + deltaX, start.y + deltaY)
    let controlPoint_2 = cc.p(end.x + deltaX, end.y + deltaY)
    return [controlPoint_1, controlPoint_2]
}

formatSecondToHHmmss = function (seconds, sep = ":") {
    seconds = seconds || 0
    let minutes = Math.floor(seconds  / 60)
    let hours = Math.floor(minutes / 60)
    return string.format(`%02d${sep}%02d${sep}%02d`, hours % 24, minutes % 60, seconds % 60)
}

emptyFunc = function () {
    
}

function createFakeText(text) {
    const isRTL = document.documentElement.getAttribute('dir') == 'rtl';
    let fakeElem = document.createElement('textarea');
    // Prevent zooming on iOS
    fakeElem.style.fontSize = '12pt';
    // Reset box model
    fakeElem.style.border = '0';
    fakeElem.style.padding = '0';
    fakeElem.style.margin = '0';
    // Move element out of screen horizontally
    fakeElem.style.position = 'absolute';
    fakeElem.style[ isRTL ? 'right' : 'left' ] = '-9999px';
    // Move element to the same position vertically
    let yPosition = window.pageYOffset || document.documentElement.scrollTop;
    fakeElem.style.top = `${yPosition}px`;

    fakeElem.setAttribute('readonly', '');
    fakeElem.value = text;
    document.body.appendChild(fakeElem);
    return fakeElem
}

copyText = function (text) {
    if(isWechatGameEnv()) {
        if(wx) {
            mini.setClipboardData({data:""+text})
            return true
        }
        return false
    }
    let fakeElem = createFakeText(text)
    let currentFocus = document.activeElement;
    fakeElem.focus();
    fakeElem.setSelectionRange(0, fakeElem.value.length);
    let successed = document.execCommand('copy', true);
    currentFocus.focus();
    fakeElem.remove()
    return successed
}

isWechatGameEnv = function () {
    return META.platform === XcloverPlatform.wechatgame
}

//
getCurrentPlatform = function () {
    return isWechatGameEnv() ? mini.getPlatform() : META.platform
}

getCurrentPlatformAllowShare = function () {
    return (!window.mini && SnsProxy.getInstance().allowShare()) || (window.mini && mini.getPlatform() == MiniPlatform.tt && SnsProxy.getInstance().curVerCanShare()) || (window.mini && mini.getPlatform() != MiniPlatform.tt && SnsProxy.getInstance().allowShare())
}


isPlatformIOS = function() {
    let platfrom = require("clover/sns/SnsProxy").getInstance().getSystemPlatfrom()
    return  platfrom === SystemPlatform.IOS
}

isIpad = function() {
    return display.width / display.height > 0.65
}
quickBuildUIButtonNoAction = quickBuildUIButtonNoAction = function (node, clickCb) {
    quickBuildBtn(node, UIButton, null, clickCb)
}

quickBuildUIButton = quickBuildUIBUtton = function (node, clickCb) {
    quickBuildBtn(node, UIButton, PushBounceAnim, clickCb)
}
levelCrashHttp = function (levelId, cb) {
    // var self = this

    if (window.alreadyCallLevelCrashHttp) return
    window.alreadyCallLevelCrashHttp = true

    function success(evt) {
        window.logCenter && logCenter.error(new Error(`levelCrashHttp success ` + levelId), 'RestartLevelDirectly')
        cb && cb()
        
    }
    let http = LevelCrashHttp.new()
    http.addEventListener(Events.kComplete, success)
    http.addEventListener(Events.kError, (evt) => {
        console.log("levelCrashHttp error evt", evt)
        // Toast.make(getText("error.tip."+ evt.data ))
        cb && cb()
    })
    http.addEventListener(Events.kCancel, (evt) => {
        console.log("levelCrashHttp cancel evt", evt)
        // Toast.make(getText("error.tip."+ evt.data ))
        cb && cb()
    })
    http.load(levelId, Localhost.time())
    
}
writeStartLevelReplayHttp = function (batchReplay, cb) {
    // var self = this

    // if (window.alreadyCallLevelCrashHttp) return
    // window.alreadyCallLevelCrashHttp = true

    function success(evt) {
        window.logCenter && logCenter.error(new Error(`writeStartLevelReplayHttp success ` + batchReplay), 'RestartLevelDirectly')
        cb && cb()
        
    }
    let http = WriteStartLevelReplayHttp.new()
    http.addEventListener(Events.kComplete, success)
    http.addEventListener(Events.kError, (evt) => {
        Toast.make(curryQuickGetErrorText(evt.data))
        cb && cb()
    })
    http.addEventListener(Events.kCancel, () => {
        cb && cb()
    })
    http.load(batchReplay)
}
sendCrashLevelDataToServer = function (cb){
    if (DCAssist.isInGaming && DCAssist.level){ //关卡内
        let lastBatchReplay = cc.UserDefault.getInstance().getStringForKey(LOCAL_LAST_BATCH_REPLAY_IN_LEVEL)
        if (lastBatchReplay){
            console.log("[crash Replay Data]", lastBatchReplay)
            writeStartLevelReplayHttp(lastBatchReplay, function(){
                cb && cb()
            })
        }else {
            levelCrashHttp(DCAssist.level, function(){
                cb && cb()
            })
        }

    }else {
        window.logCenter && logCenter.error(new Error(`not in level restart`), 'RestartLevelDirectly')
        cb && cb()
    }
}
quickBuildUIGLabelButton = function (node, clickCb) {
    quickBuildBtn(node, UIGLabelButton, PushBounceAnim, clickCb)
}
quickBuildBtn = function (node, BtnClass, AnimClass, clickCb) {
    if (!(node instanceof cc.Node)) {
        cc.error("node must be instanceof cc.Node")
        return
    }
    BtnClass.create(node, true)
    if (AnimClass) {
        AnimClass.create(node)
    }
    if (clickCb)
        node.on(UIButtonEvent.Click, clickCb);
}

curryQuickGetErrorText = (function () {
    let defaultValue = "网络异常状态，请检查网络连接！"
    return function (code) {
        return quickGetErrorText(code, defaultValue)
    }
})()
quickGetErrorText = function (code, defaultValue) {
    let key = "error.tip." + code
    let text = getText(key)
    return key === text ? defaultValue : text
}

/**
 *  展示人民币购买失败提示
 */
showRMBPayFailMsg = function(evt, onComplete) {
    let errorMsg
    if (evt && evt.data) {
        if (evt.msg) {
            errorMsg = evt.msg
        } else if (evt.data) {
            if (typeof evt.data == "number") {
                errorMsg = getText("error.tip." + evt.data)
            } else {
                errorMsg = evt.data
            }
        }
    } else {
        errorMsg = getText("payment.tip.failure")
    }
    if (errorMsg.length > 16) {
        CommonConfirmPanel.show({
            content: errorMsg,
            onClose: onComplete,
            onSure: onComplete,
            sureText: getText("clover.text.18")
        });
    } else {
        Toast.make(errorMsg, null, onComplete)
    }
}
showNodeBoundingBox = function (node, color = cc.color(255, 0, 0, 125)) {
    if (__DEBUG && node.parent) {
        clearNodeBoundingBox(node)
        let rect = node.getBoundingBox()
        let drawNode = cc.DrawNode.create()
        drawNode.drawRect(rect, cc.p(rect.x + rect.width, rect.y + rect.height), color)
        node.parent.addChild(drawNode, 100)
        node.myBoundingBox = drawNode
    }
}
clearNodeBoundingBox = function (node) {
    if (node && node.myBoundingBox) {
        node.myBoundingBox.removeFromParent(true)
        node.myBoundingBox = null
    }
}
timeLimitCallbackFunc = function (callback, times = 1) {
    let calledTimes = times
    return function (...args) {
        if (--calledTimes <= 0) {
            callback && callback(args)
        }
    }
}
replaceNode = function (oldNode, newNode) {
    if ( !(oldNode instanceof cc.Node)  || !(newNode instanceof cc.Node) ) {
        return
    }
    let name_node = oldNode.getName()
    let z_order = oldNode.getLocalZOrder()
    let arrivalOrder = oldNode.getOrderOfArrival()
    let [scaleX, scaleY] = [oldNode.getScaleX(), oldNode.getScaleY()]
    newNode.setScaleX(scaleX)
    newNode.setScaleY(scaleY)
    newNode.setPosition(oldNode.getPosition())
    newNode.setName(oldNode.getName())
    newNode.setLocalZOrder(z_order)
    newNode.setOrderOfArrival(arrivalOrder)
    // let extensionData = oldNode.getComponent("ComExtensionData")
    // if (extensionData) {
    //     oldNode.removeComponent("ComExtensionData")
    //     newNode.addComponent(extensionData)
    // }
    if (oldNode.setCascadeColorEnabled && newNode.setCascadeColorEnabled) {
        newNode.setCascadeColorEnabled(oldNode.isCascadeColorEnabled())
    }
    if (oldNode.setCascadeOpacityEnabled && newNode.setCascadeOpacityEnabled) {
        newNode.setCascadeOpacityEnabled(oldNode.isCascadeOpacityEnabled())
    }
    if (oldNode.getParent()) {
        oldNode.getParent().addChild(newNode)
        if (name_node) {
            newNode.setName(name_node)
        }
        oldNode.removeFromParent(true)
    }
}

OnceCalledCallback = function (callback) {
    let called = false
    return function (...args) {
        if (!called) {
            callback && callback(args)
            call = true
        }
    }
}

/**
 * 作用：传入的函数只要有一个被调用，其他的函数都不会被调用，
 * 一般用在 防止回调函数多次被调用的情况，参数必须都是 函数 或者 空
 * 示例：[a, b ,c] = HookFuncCalledOnce(a, b, c)
 */
HookFuncsCalledOnce = function (...args) {
    let called = false
    let invided = false
    args.forEach((item) => {
        if ( item != null && typeof item !== "function" ) {
            invided = true
        }
    })
    if (invided && __DEBUG) {
        throw new Error("HookFuncCalledOnce param shoule be all function or null")
    }
    return args.map((item) => {
        return function () {
            if (!called) {
                called = true
                item && item(...arguments)
            }
        }
    })
}

LogToLogCenter = function (error) {
    let isError = Object.prototype.toString.call(error) === "[object Error]"
    if (!__DEBUG && window.logCenter && isError) {
        logCenter.error(error, "initiative")
    }else {
        cc.error(error)
    }
}

PerformanceTestFunc = function (testFunc, times = 100000) {
    let tag = `${testFunc.name} PerformanceTestFunc`
    //console.time(tag)
    for (let index = 0; index < times; index++) {
        testFunc()
    }
    //console.timeEnd(tag)
}

/**
 * anchorPoint = cc.p(1,1)
 * 此方法会根据 node 的 contentsize 来调整 position，所以 node 的 contentSize 不准的情况下可能会有问题
 */
SetAnchorPointIgnorePosition = function (node, anchorPoint) {
    let oldAnchor = node.getAnchorPoint()
    let oldPos = node.getPosition()
    let size = node.getContentSize()
    let anchorDelta = cc.pSub(anchorPoint, oldAnchor)
    node.setAnchorPoint(anchorPoint)
    node.setPosition(cc.pAdd(oldPos, cc.p(size.width * anchorDelta.x, size.height * anchorDelta.y)))
}

/**
 * 基于 node2 计算 node1 在node2 中间的位置
 */
CalcRelativeCenterPos = function (node1, node2) {
    let size1 = node1.getContentSize()
    let size2 = node2.getContentSize()
    let anchor1 = node1.getAnchorPoint()
    let anchor2 = node2.getAnchorPoint()
    let x = node2.x + size2.width  * (0.5 - anchor2.x) - (0.5 - anchor1.x) * size1.width
    let y = node2.y + size2.height * (0.5 - anchor2.y) - (0.5 - anchor1.y) * size1.height
    return cc.p(x, y)
}


/**
 * 根据路径获取子项
 * @param {cc.Node} root 父系节点
 * @param {string} path 访问路径，以'/'隔开
 * 
 * @return {cc.Node} 子项
 */
GetChildByPath = function(root, path) {
    let v = root;
    let ary = path.split('/');
    for(let i = 0; i < ary.length; i++) {
        v = v.getChildByName(ary[i]);
        if (v == null)
            return null;
    }
    return v;
}

/**
 * 校准BMFont
 * frame中initTextBMFont方法没有处理对齐方式
 */
AlignTextBMFont = function(root, pathList) {
    pathList = $tableToArray(pathList);
    pathList.forEach((path)=> {
        let textBMFont = GetChildByPath(root, path);
        let hAlign = textBMFont.getTextHorizontalAlignment();
        let width = textBMFont.getContentSize().width;
        let orgX = textBMFont.getPositionX() - width * textBMFont.getAnchorPoint().x;
        let newAX = 0;
        if (hAlign == 1)
            newAX = 0.5;
        else if (hAlign == 2)
            newAX = 1;
        textBMFont.setAnchorPoint(newAX, textBMFont.getAnchorPoint().y);
        textBMFont.setPositionX(orgX + width * newAX);
    });
}

/**
 * 横向对齐一组节点
 */
HorizontalNodeGroup = function(nodeArray, center, gap = 2) {
    let w = 0;
    nodeArray.forEach((node)=> w += node.getContentSize().width * node.getScaleX());
    
    let startX = center.x - w / 2 - gap * (nodeArray.length - 1) / 2;
    nodeArray.forEach((node)=> {
        node.setPosition(startX, center.y);
        startX += node.getContentSize().width * node.getScaleX() + gap;
    });
}

/**
 * 显示蒙版
 */
showGlobalMask = function(tag) {
    GlobalMask.Active(tag);
}

/**
 * 隐藏蒙版
 */
hideGlobalMask = function(tag) {
    GlobalMask.Unactive(tag);
}

/**
 * 格式化金钱
 * @param {number} fen
 * 
 * @return {number} 元
 */
formatMoneyToYuan = function(fen) {
    let str = string.format("%0.2f", fen / 100);
    let ary = str.split(".");
    if (ary.length < 2)
        return str;
    else {
        ary[1] = ary[1].replace(/0+$/g, '');
        if (ary[1].length == 0)
            return ary[0];
        else
            return ary[0] + "." + ary[1];
    }
}

/**
 * 计算LabelTTF应该有的size
 */
CalculateLbTTFSize = function(orgLbTTF, text, width) {
    let dimensions = width == null? null: cc.size(width, 0);
    let orgLb = orgLbTTF.getVirtualRenderer();
    if (orgLb == null)
        orgLb = orgLbTTF;

    let tempLb = cc.LabelTTF.create(text === undefined? orgLb.getString(): text, orgLb.getFontName(), orgLb.getFontSize(), dimensions);
    tempLb._setFontWeight(orgLb._getFontWeight());
    return tempLb.getContentSize();
}

/**
 * 根据CSB创建动画节点
 */
QuickCreateAnimNode = function(csb) {
	let node = cc.CSLoader.createNode(csb);
	let actionTimeLine = cc.CSLoader.createTimeline(csb);
    if (actionTimeLine == null) {
        cc.log("needpreload : failed to load " + csb);
        return; 
    }
    node.actionTimeLine = actionTimeLine
    node.runAction(actionTimeLine);

    return node;
}

/**
 * 解析 ${itemId}:${itemNum}格式字符串
 */
ParseItems = function(str) {    
    if (!str)
        return null;
    
    let groups = str.split(',')
    let result = []
    let tmpAry = null
    groups.forEach(v=> {
        v = v.trim()
        if (v) {
            tmpAry = v.split(':')
            result.push({itemId: tmpAry[0], num: parseInt(tmpAry[1])})
        }
    })
    return result;
}

findNode = function (root, path)
{
    let names = path.split("/")

    while (names.length > 0)
    {
        let name = names.shift()
        let node = root.getChildByName(name)
        root = node
    }
    return root
}

cloneUINode = function(obj, copypos)
{
    var newObj = (obj.constructor) ? new obj.constructor : {};


    if (obj._children && obj._children.length > 0)
    {
        for (var i = 0; i < obj._children.length; i++)
        {
            let newNode = cloneUINode(obj._children[i], true)
            newObj.addChild(newNode)
        }
    }

    if (obj._className == "ImageView")
    {
        newObj._copySpecialProperties(obj)
    }
    else if (obj._className == "Sprite")
    {
        newObj.initWithTexture(obj._texture, obj._rect, obj._rectRotated)
    }
    else if (obj._className == "TextBMFont")
    {
        newObj._copySpecialProperties(obj)
    }
    else
    {
      //  console.log(obj._className)
    }

    if (obj._contentSize)
    {
        newObj.setContentSize(obj._contentSize)
    }
    newObj._name = obj._name
    newObj.scaleX = obj.scaleX
    newObj.scaleY = obj.scaleY
    newObj.color = cc.clone(obj.color)
    newObj.anchorX = obj.anchorX
    newObj.anchorY = obj.anchorY
    newObj.skewX = obj.skewX
    newObj.skewY = obj.skewY
    newObj.rotation = obj.rotation
    newObj.rotationX = obj.rotationX
    newObj.rotationY = obj.rotationY
    if (obj._anchorPoint)
    {
        newObj._anchorPoint = cc.clone(obj._anchorPoint)
    }
    if (copypos)
    {
        newObj.x = obj.x
        newObj.y = obj.y
    }
    else
    {
        if (newObj._renderCmd)
        {
            newObj._renderCmd._anchorPointInPoints = new cc.Point(0,0)
        }
    }


    return newObj;
}

instantiate = function(obj)
{
    var newObj = (obj.constructor) ? new obj.constructor : {};
    return newObj;
}

loadExpression = function(expressionStr){
    // console.log("loadExpression expressionStr ",expressionStr)
    if (expressionStr.indexOf("(") != -1){
        expressionStr = expressionStr.replace(/\(([^).]*)\)/g,"$1")
    }
    console.log("loadExpression expressionStr ",expressionStr)
    if (expressionStr.indexOf(" or ") != -1){
        let t = expressionStr.split(" or ");
        for (var i = 0; i < t.length; i++){
            if (loadExpression(t[i])){
                return true;
            }
        }
        return false;
    }else if (expressionStr.indexOf(" and ") != -1){
        let t = expressionStr.split(" and ");
        for (var i = 0; i < t.length; i++){
            if (!loadExpression(t[i])){
                return false;
            }
        }
        return true;
    }else if (expressionStr.indexOf(">=") != -1){
        let t = expressionStr.split(">=");
        t[0] = loadExpression(t[0]);
        t[1] = loadExpression(t[1]);
        if (tonumber(t[0]) >= tonumber(t[1])){
            return true;
        }else{
            return false;
        }
    }else if (expressionStr.indexOf("<") != -1){
        let t = expressionStr.split("<");
        t[0] = loadExpression(t[0]);
        t[1] = loadExpression(t[1]);
        if (tonumber(t[0]) < tonumber(t[1])){
            return true;
        }else{
            return false;
        }
    }else if (expressionStr.indexOf("+") != -1){
        let t = expressionStr.split("+");
        t[0] = loadExpression(t[0]);
        t[1] = loadExpression(t[1]);
        return tonumber(t[0]) + tonumber(t[1]);
    }
    return expressionStr;
}

// LogToLogCenterNew = function (error,category) {
//     if(!category) category = "HBXXL_PASS_LV"
//     cc.log("LogToLogCenterNew ",error,__DEBUG,category)
//     let pf = isWechatGameEnv() ? mini.getPlatform() : META.platform
//     // window.mini && mini.getPlatform() === MiniPlatform.wechatGame
//     if (!global.mini || pf != MiniPlatform.wechatGame){
//         cc.log("LogToLogCenterNew 不在微信平台",pf)
//         return
//     }
//     if (!__DEBUG && window.logCenter) {
//         window.logCenter && logCenter.error(new Error(`flow path,${error}`), category);
//     }else {
//         cc.error(error)
//     }
// }



if (__DEBUG) {
    // ================= 前端自动跑关Start ========================
    const AUTORUN_KEY = "debugAutoRun";
    var preprops = $table([10008, 10009, 10009, 10011, 10011]) //默认投放所有道具

    /**
     * 从levelId开始依次打开主线关卡
     * @param levelId
     */
    AutoRun = function(levelId, keepData, noPreprops) {
        levelId = levelId == null? 1: levelId
        if (!keepData) {
            Persistence.writeFileData(table(), AUTORUN_KEY);
            if (noPreprops){
                preprops = table()
            }
        }
        _G.autoRunLevel = levelId
        console.log("======AutoRun [levelId: "+levelId+"]======", preprops);
        require("clover/gamePlay/CreateGameSceneLogic")
        let instance = CreateGameSceneLogic.create(levelId, preprops)
        instance.startGamePlayScene((fileList)=>{
            instance.createGamePlayScene(fileList)
        },(err)=>{console.error("instance.startGamePlaySceneLogic error:", err)})
        cc.Director.getInstance().getScheduler().setTimeScale(20)
    }
    /**
     * 停止前端自动跑关
     */
    StopAutoRun = function() {
        delete _G["autoRunLevel"]
    }

    AutoRunEnterLevel = function(curLevel, state) {
        if (_G.autoRunLevel == curLevel) {
            let data = Persistence.readFileData(AUTORUN_KEY, table());
            data[curLevel] = state;
            Persistence.writeFileData(data, AUTORUN_KEY);
            AutoRun(curLevel + 1, true);
        }
    }
    /**
     * 显示跑关记录
     */
    AutoRunLog = function() {
        let data = Persistence.readFileData(AUTORUN_KEY, table());
        return data;
    }
    /**
     * 显示跑关记录中初始道具投放有问题的关卡
     */
     AutoRunPropsLog = function() {
        let data = Persistence.readFileData(AUTORUN_KEY, table());
        let result = table()
        table.each(data, function (v, k) {
            if (v == "propsError") {
                table.insert(result, k)
            }
        })
        return result;
    }
    
    // ================= 前端自动跑关End ========================

    /**
     * 恢复关卡
     * @param 关卡数据 
     * {
     *      level: number, 
     *      randomSeed: number, 
     *      replaySteps: {[key: number]: object},
     *      isOver: boolean,
     *      selectedItemsData: {[key: number]: number},
     *      reviveRef: {[key: number]: number[]}
     * }
     */
    RunReplay = function(replayData) {
        if (typeof(replayData) == "string")
            replayData = JSON.parse(replayData);

        if(replayData.hasOwnProperty("content")) {
            replayData = replayData["content"];
            if (typeof(replayData) == "string")
                replayData = JSON.parse(replayData);
        }

        if (replayData.hasOwnProperty("replay"))
            replayData = replayData["replay"];         
            
        replayData = ReplayManager.getInstance().formatter.unformat(replayData)
        if (replayData.hasOwnProperty("1"))
            replayData = replayData["1"]
            
        console.log("unformatData:", replayData)
        let replay = $table(replayData)
        let levelId = replay.level
        let selectedItemsData = replay.selectedItemsData
        let levelType = LevelType.getLevelTypeByLevelId(levelId)
        let currentLevel = UserLevel.getInstance().levelTypeEnum[levelType].create(levelId, selectedItemsData)
        UserLevel.getInstance().setCurrentLevel(currentLevel)
        PopoutManager.getInstance().removeAll()
        let logic = CreateGameSceneLogic.create(levelId, table())
        logic.startReplayGamePlayScene(replay, replay.id, replay.score)
    }
    SetOrthTestGroupId = function(_testGroupId){
        OrthGroupHelper.getInstance()._testGroupId = tonumber(_testGroupId);
        return "强制指定分组" + _testGroupId;
    }
    SetOrthTestPayment28DayTag = function(_payment28Day){
        OrthGroupHelper.getInstance()._payment28Day = tonumber(_payment28Day);
        return "强制使用【payment28Day】" + _payment28Day;
    }
    SetOrthTestActive7DayTag = function(_active7Day){
        OrthGroupHelper.getInstance()._active7Day = tonumber(_active7Day);
        return "强制使用【active7Day】" + _active7Day;
    }
    SetOrthTestNewUser7DayTag = function(_newUser7Day){
        OrthGroupHelper.getInstance()._newUser7Day = tonumber(_newUser7Day);
        return "强制使用【newUser7Day】" + _newUser7Day;
    }
    SetOrthTestLevelAreaRealTimeTag = function(_levelAreaRealTime){
        OrthGroupHelper.getInstance()._levelAreaRealTime = tonumber(_levelAreaRealTime);
        return "强制使用【levelAreaRealTime】" + _levelAreaRealTime;
    }
    SetOrthTestWeightMod = function(_weightMod){
        OrthGroupHelper.getInstance()._weightMod = tonumber(_weightMod);
        return "强制指定取模" + _weightMod;
    }
    ForceLoadLevel = function(levelId, levelConfig){
        if (!levelId){
            levelId = UserManager.getInstance().getUserRef().getTopLevelId()
        }
        let url = `meta/level/${levelId}.json`;
        cc.loader.cache[url] = $table(JSON.parse(levelConfig));
        console.log(cc.loader.cache[url])
        return "强制缓存" + levelId + "关";
    }
    // 强制修改已经使用步数
    ForceSetUseStep = function(step) {
        console.log("ForceSetUseStep 修改使用步数 "+step)
        var scene = cc.Director.getInstance().getRunningScene();
        scene.logic.gameMode.realCostMove = step
    }
}
// 强制过关
ForcePassLevel = function(star) {
    console.log("该命令为测试命令，慎用！可能导致账号禁用！！！")
    let Http = require("clover/utils/Http")
    if (!__DEBUG && Http.hostQuery != "env=qa"){
        console.log("该命令为测试命令，仅在测试及特殊环境有效")
        return
    }
    if(!star){
        console.log("ForcePassLevel star 参数为空 ")
        return
    }
    console.log("ForcePassLevel 快速通关 "+star)
    var scene = cc.Director.getInstance().getRunningScene()
    var levelid = scene.levelID
    if (levelid && star) {
        var levelConfig = LevelConfigManager.getInstance().getLevelConfigByID(levelid)
        var scores = levelConfig.scoreTargets
        if (star > $len(scores)) {
            star = $len(scores)
        }
        // console.error("[NewRank]","这是一段通关关闭作弊分数标识的代码，请及时删除！")
        var score = scores[star] //+ 2: scores[star]
        function onSuccess() {
            //Toast:make("level pass complete")
        }
        // let levelType = LevelType.getLevelTypeByLevelId(self.custom_levelId)
        let targetNum = 0
        if (levelConfig.gameMode === GamePlayType.kTimeBlockCollection) {
            targetNum = 100
        }
        scene.passLevel(levelid, score, star, 100, 0, targetNum, null, 0, true , LevelType.isMysteryIslandLevel(levelid))
    }
}    
// // 强制修改pvr
// PVRChange = function(flag) {
//     if (flag == "f"){
//         cc.UserDefault.getInstance().setBoolForKey("TestPVRFail", true)
//     }else{
//         cc.UserDefault.getInstance().setBoolForKey("TestPVRFail", false)
//     }
// }
// 强制修改步数
ForceSetStep = function(step) {
    console.log("该命令为测试命令，慎用！可能导致账号禁用！！！")
    let Http = require("clover/utils/Http")
    if (!__DEBUG && Http.hostQuery != "env=qa" && UserManager.getInstance.canUseGMCmd == false){
        console.log("该命令为测试命令，仅在测试及特殊环境有效")
        return
    }
    if(!step){
        console.log("ForceSetStep step 参数为空 ")
        return
    }
    console.log("ForceSetStep 修改步数 "+step)
    var scene = cc.Director.getInstance().getRunningScene();
    scene.setMoveOrTimeCountCallback(step, true, true);
    scene.logic.setTheCurMoves(step);
}
// 强制解除使用道具限制
ForceUnlimitUseProp = function() {
    let Http = require("clover/utils/Http")
    if (!__DEBUG && Http.hostQuery != "env=qa" && UserManager.getInstance.canUseGMCmd == false){
        console.log("该命令为测试命令，仅在测试及特殊环境有效")
        return
    }
    UserManager.getInstance().canGmPropUse = true
}
// 制定星级过关
ForceWinWithStar = function(star){
    DAManager.getInstance().endLevel()
    var scene = cc.Director.getInstance().getRunningScene()
        if (window.mini && mini.getPlatform() == MiniPlatform.tt){
            var logic = scene.logic;
            if (logic.ttRecording){
                logic.ttRecorder.stop();
                setTimeout(()=>{
                    ForceWinWithStar(star);
                }, 2000);
                return;
            }
        }
        var levelid = scene.levelID
        if (levelid && star) {
            var levelConfig = LevelConfigManager.getInstance().getLevelConfigByID(levelid)
            var scores = levelConfig.scoreTargets
            if (star > $len(scores)) {
                star = $len(scores)
            }
            // console.error("[NewRank]","这是一段通关关闭作弊分数标识的代码，请及时删除！")
            var score = scores[star] //+ 2: scores[star]
            // function onSuccess() {
                //Toast:make("level pass complete")
            // }
            let targetNum = 0
            if (levelConfig.gameMode === GamePlayType.kTimeBlockCollection) {
                targetNum = 100
            }
            scene.passLevel(levelid, score, star, 100, 0, targetNum, null, 0, true , LevelType.isMysteryIslandLevel(levelid))
        }
}
    